import { render } from "./PageControls.vue?vue&type=template&id=f4b787a4"
import script from "./PageControls.vue?vue&type=script&lang=js"
export * from "./PageControls.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nika/Sites/tanastsoroba-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__